import Component from "flarum/common/Component";
import craftBadges from "../utils/craftBadges";
import craftTags from "../utils/craftTags";
import humanTime from 'flarum/common/utils/humanTime';
import icon from 'flarum/common/helpers/icon';
import username from 'flarum/common/helpers/username';
import Dropdown from 'flarum/common/components/Dropdown';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Link from 'flarum/common/components/Link';
import { truncate } from 'flarum/common/utils/string';
import LastReplies from './LastReplies';
import { triggerLayoutUpdate } from '../index'; // 引入全局的布局触发器

/**
 * 严格过滤：排除表情、头像、折叠区、剧透区、聊天室及编辑中的图片
 */
function getFilteredImages(post) {
  if (!post || !post.contentHtml()) return [];

  const container = document.createElement('div');
  container.innerHTML = post.contentHtml();

  const excludeSelector = 'img[data-src], img[is-preview], img[isfancy], img.emoji, img.Avatar, img.flaemoji-customized, img[data-reaction], img[data-link-preview]';
  const containerSelector = ':is(blockquote, details, .bbspoiler-blur, .chatroom, .no-fancybox) img, .editing img';

  let imgs = Array.from(container.querySelectorAll('img'));

  return imgs.filter(img => {
    const isExcludedType = img.matches(excludeSelector);
    const isInExcludedContainer = img.matches(containerSelector) || 
                                  img.closest('blockquote, details, .bbspoiler-blur, .chatroom, .no-fancybox, .editing');
    return !isExcludedType && !isInExcludedContainer;
  }).map(img => img.getAttribute('src'));
}

/**
 * URL 优化：防止重复后缀，并过滤非本站域名的外链
 */
function getOptimizedSrc(url) {
  if (!url) return '';
  if (/(\.small|\.medium|\.large|\.thumb)\.(jpg|jpeg|png|gif|webp)$/i.test(url)) {
    return url;
  }
  const baseUrl = app.forum.attribute('baseUrl').replace('https://','');
  if (url.startsWith('http') && !url.includes(baseUrl)) {
    return url;
  }
  return url.replace(/(\.jpg|\.jpeg|\.png)$/i, '.medium$1');
}


export default class cardItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.discussion = this.attrs.discussion;
  }

  view() {
    const discussion = this.discussion;
    const settings = JSON.parse(app.forum.attribute('dem13nDiscussionCards'));
    const isRead = settings.markCards === 1 && (!discussion.isRead() && app.session.user) ? 'Unread' : '';
    const attrs = { className: "wrapImg" + (settings.cardFooter === 1 ? " After" : '') };

    const images = getFilteredImages(discussion.firstPost());
    const DURATION_PER_IMG = 2;
    const imgCount = images.length;
    const totalDuration = imgCount * DURATION_PER_IMG;
    const TRANSITION_DURATION = 0.5;

    let dynamicKeyframes = null;

    if (imgCount > 1) {
      let keyframeCSS = '';
      for (let i = 0; i < imgCount - 1; i++) {
        const animName = `slideshow-count-${imgCount}-idx-${i}`;
        if (i === 0) {
          const p1 = ((DURATION_PER_IMG - TRANSITION_DURATION) / totalDuration * 100).toFixed(2);
          const p2 = (DURATION_PER_IMG / totalDuration * 100).toFixed(2);
          const p3 = ((totalDuration - TRANSITION_DURATION) / totalDuration * 100).toFixed(2);
          keyframeCSS += `
            @keyframes ${animName} {
              0%, ${p1}% { opacity: 1; }
              ${p2}%, ${p3}% { opacity: 0; }
              100% { opacity: 1; }
            }
          `;
        } else {
          const p1 = (((i + 1) * DURATION_PER_IMG - TRANSITION_DURATION) / totalDuration * 100).toFixed(2);
          const p2 = (((i + 1) * DURATION_PER_IMG) / totalDuration * 100).toFixed(2);
          keyframeCSS += `
            @keyframes ${animName} {
              0%, ${p1}% { opacity: 1; }
              ${p2}%, 99.9% { opacity: 0; }
              100% { opacity: 1; }
            }
          `;
        }
      }
      dynamicKeyframes = <style>{keyframeCSS}</style>;
    }

    const media = imgCount > 0
      ? images.map((image, index) => {
          const isBottom = index === imgCount - 1;
          const animName = `slideshow-count-${imgCount}-idx-${index}`;

          return (
            <img
              key={image}
              src={getOptimizedSrc(image)}
              className="previewCardImg"
              alt={discussion.title()}
              loading="lazy"
              oncreate={(vnode) => {
                const img = vnode.dom;
                const checkRatio = (isError = false) => {
                  const card = img.closest('.CardsListItem');
                  if (!card) return;

                  if (!card.dataset.loadedImages) {
                    card.dataset.loadedImages = '0';
                    card.dataset.flatImages = '0';
                    card.dataset.longImages = '0';
                  }

                  card.dataset.loadedImages = String(parseInt(card.dataset.loadedImages) + 1);

                  if (!isError) {
                    if (img.naturalWidth / img.naturalHeight > 4 / 3) {
                      card.dataset.flatImages = String(parseInt(card.dataset.flatImages) + 1);
                    }
                    if (img.naturalHeight / img.naturalWidth > 1.2) {
                      card.dataset.longImages = String(parseInt(card.dataset.longImages) + 1);
                    }
                  }

                  if (parseInt(card.dataset.loadedImages) === imgCount) {
                    if (parseInt(card.dataset.flatImages) >= imgCount / 2) {
                      card.classList.add('is-flat-img');
                    } else {
                      card.classList.remove('is-flat-img');
                    }

                    if (parseInt(card.dataset.longImages) >= imgCount / 2) {
                      card.classList.add('is-long-img');
                    } else {
                      card.classList.remove('is-long-img');
                    }

                    const container = card.parentElement;
                    if (container) {
                         // 直接呼叫全局触发器，它内部自带了 50ms 的 setTimeout 防抖锁
                        triggerLayoutUpdate(container);
                    }
                  }
                };

                if (img.complete) {
                  if (img.naturalWidth === 0) {
                    img.removeAttribute('src'); // 已经失败的缓存图，直接移除 src
                    checkRatio(true);
                  } else {
                    checkRatio(false);
                  }
                } else { 
                  img.onload = () => checkRatio(false); 
                  img.onerror = () => {
                    img.onerror = null;         // 1. 立即注销 onerror 事件，防止发生事件死循环
                    img.removeAttribute('src'); // 2. 拔掉网线：清空 src，彻底阻断浏览器的懒加载无限重试机制
                    checkRatio(true);
                  }; 
                }
              }}
              style={imgCount > 1 && !isBottom ? {
                animation: `${animName} ${totalDuration}s infinite linear`
              } : {}}
            />
          );
        }).reverse()
      : <div className="imgStub" />;

    return (
      <div key={discussion.id()}
           data-id={discussion.id()}
           className={"CardsListItem Card " + isRead + (discussion.isHidden() ? " Hidden" : "")}
           oncontextmenu={(e) => {
             e.preventDefault();
             const btn = e.currentTarget.querySelector('.DiscussionListItem-controls button');
             if (btn) btn.click();
           }}>
        {DiscussionControls.controls(discussion, this).toArray().length
          ? m(Dropdown, {
            icon: 'fas fa-ellipsis-v',
            className: 'DiscussionListItem-controls',
            buttonClassName: 'Button Button--icon Button--flat Slidable-underneath Slidable-underneath--right',
          }, DiscussionControls.controls(discussion, this).toArray())
          : ''}
        <Link href={app.route.discussion(discussion, 0)} className="cardLink">
          {settings.cardBadges === 1 ? craftBadges(discussion.badges().toArray()) : ''}
          <div {...attrs}>
            {settings.Views === 1 && !isNaN(discussion.views())
              ? <div className="imageLabel discussionViews">
                  {icon('fas fa-eye', { className: 'labelIcon' })}
                  {discussion.views()}
                </div>
              : ''}
            {dynamicKeyframes}
            {media}
            {settings.cardFooter === 1
              ? <div className="cardFoot">
                  <div className="Author">{username(discussion.user())}</div>
                  <div className="Date">{humanTime(discussion.createdAt())}</div>
                </div>
              : ''}
          </div>
          <div className="cardTags">{craftTags(discussion.tags())}</div>
          <div className="cardTitle"><h2>{discussion.title()}</h2></div>
          {settings.previewText === 1 && discussion.firstPost()
            ? <div className="previewPost">{truncate(discussion.firstPost().contentPlain(), 150)}</div>
            : ''}
          {settings.Replies === 1
            ? <div className="cardSpacer">
                <Link className="Replies" href={app.route.discussion(discussion, discussion.lastPostNumber())}>
                  <div className="Left">
                    <div className="Avatars">{m(LastReplies, { discussion: discussion })}</div>
                    <div className="Repcount">
                      {app.translator.trans('dem13n.forum.replies', { count: discussion.replyCount() || '0' })}
                    </div>
                  </div>
                  <div className="Arrow">{icon('fas fa-angle-right')}</div>
                </Link>
              </div>
            : ''}
        </Link>
      </div>
    );
  }
}